import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'displayValue' })
export class DisplayValuePipe implements PipeTransform {

    transform(value: number, lookups: any[]) {
        return this.getLookupValue(lookups, value);
    }

    getLookupValue(table: any[], id: number) {
        // attempts to use select list item
        let foundValue = table.find(i => +i.value === +id);
        if (foundValue) {
            if (foundValue.text) {
                return foundValue.text;
            } else if (foundValue.displayValue) {
                return foundValue.displayValue;
            }
        } else {
            // attempts to use generated enums
            foundValue = table.find(i => +i.id === +id);
            if (foundValue) {
                if (foundValue.displayValue) {
                    return foundValue.displayValue;
                }
            }
        }
        return undefined;
    }
}
